export const PORTALS = {
  SeeAllImages: 'SeeAllImages',
  SeeAllStorylines: 'SeeAllStorylines',
  SeeAllTrending: 'SeeAllTrending',
  TopUpBalance: 'TopUpBalance',
  GenerateImage: 'GenerateImage',
  ExampleImage: 'ExampleImage',
  GeneratePhotoByPhoto: 'GeneratePhotoByPhoto',
  GenerateInpaint: 'GenerateInpaint',
  InpaintMode: 'InpaintMode',
  GodMode: 'GodMode',
  AnyImageToVideo: 'AnyImageToVideo',
  AllTools: 'AllTools',
  ProfilePhotoTools: 'ProfilePhotoTools',
  AnimateProfilePhoto: 'AnimateProfilePhoto',
  RepeatFeedPhoto: 'RepeatFeedPhoto',
  MySubscribers: 'MySubscribers',
  MySubscriptions: 'MySubscriptions',
  UserSubscribers: 'UserSubscribers',
  UserSubscriptions: 'UserSubscriptions',
};
